import { Component, Input, OnInit } from "@angular/core";
import {
  CustomColumnComponent,
  DataService,
  SharedModule,
} from "@bb-vendure/admin-ui/core";
import { Observable, switchMap, map, take } from "rxjs";

@Component({
  selector : 'stock-quantites-column',
  imports: [SharedModule],
  standalone: true,
  templateUrl: "./stock-quantites.component.html",
})
export class StockQuantitiesComponent implements CustomColumnComponent, OnInit {
  @Input() rowItem: { id: string };

  totalStock$: Observable<number>;

  constructor(private dataService: DataService) {}

  ngOnInit(): void {
    //console.log(this.rowItem);
    this.totalStock$ = this.dataService.product
      .getProductVariants({
        filter: {
          productId: {
            eq: this.rowItem.id,
          },
        },
      })
      .mapStream(({ productVariants }) => productVariants.items)
      .pipe(
        map((items, _) => {
          let total = 0;
          for (const i of items) {
            const stock = i.stockLevels[0]?.stockOnHand ?? 0;
            total += stock;
          }

          return total;
        })
      );
  }
}
